import React from 'react';
import {Modal} from "react-bootstrap";
import {connect} from "react-redux";
import UpgradeCard from "../UpgradeCard";
import {hideUpgradeCardModal} from "../../actions";

import './upgrade-modal-content.css'

const UpgradeModal = ({show, desc, cta, onClick, dispatch}) => {
  const onUpgradeCardClick = () => {
    dispatch(hideUpgradeCardModal());

    if (onClick)
      setTimeout(onClick(), 300);
  }

  return <Modal
    aria-labelledby="contained-modal-title-vcenter"
    show={show}
    onHide={() => dispatch(hideUpgradeCardModal())}
    dialogClassName="upgrade-modal-content"
    backdropClassName="upgrade-modal-backdrop"
    centered
  >
    <UpgradeCard
      className="m-auto box-shadow"
      desc={desc}
      cta={cta || 'Contact support to upgrade'}
      onClick={onUpgradeCardClick}
    />
  </Modal>
};

const mapStateToProps = ({ upgrade }) => ({
  ...upgrade,
})

const mapDispatchToProps = (dispatch) => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(UpgradeModal);
